import { Stack, Typography } from '@mui/material';
import { DefaultMeetingSession } from 'amazon-chime-sdk-js';
import { FC, useEffect, useRef } from 'react';
import { Participant } from '../../meeting-call.types';

type VideoTrackProps = {
  participant: Participant;
  session: DefaultMeetingSession | null;
  className?: string;
  isScreenShare?: boolean;
};

const VideoTrack: FC<VideoTrackProps> = ({ participant, session, className, isScreenShare }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!session || !videoRef.current) {
      return;
    }

    const tileId = participant.tileState.tileId;
    if (!tileId) {
      return;
    }

    session.audioVideo.bindVideoElement(tileId, videoRef.current);
    return () => {
      session.audioVideo.unbindVideoElement(tileId);
    };
  }, [session, participant.tileState?.tileId]);

  return (
    <Stack className={`chime-video-call-container__video-track ${className}`}>
      <Stack className='chime-video-call-container__participant-name'>
        <label>
          {participant.name ? participant.name : participant.tileState.boundExternalUserId}
        </label>
      </Stack>
      {!participant.isCameraEnabled && !participant.isSharing && (
        <Stack className='chime-video-call-container__no-video-label'>
          <Typography variant='h2'>No video</Typography>
        </Stack>
      )}
      <video ref={videoRef} className='chime-video-call-container__video' />
    </Stack>
  );
};

export default VideoTrack;
